export default function ComparisonSection() {
  const rows = [
    { label: 'Czas wyszukiwania', google: 'Długi', kakobuy: 'Krótki' },
    { label: 'Łatwość użycia', google: 'Średnia', kakobuy: 'Wysoka' },
    { label: 'Ryzyko zakupu', google: 'Wysokie', kakobuy: 'Niższe' },
    { label: 'Jakość produktów', google: 'Nieznana', kakobuy: 'Sprawdzona' },
    { label: 'Aktualność danych', google: 'Różna', kakobuy: 'Regularna' },
    { label: 'Wsparcie użytkownika', google: 'Brak', kakobuy: 'Dostępne' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Dlaczego warto korzystać z Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Porównanie tradycyjnego wyszukiwania w Google z korzystaniem z arkusza Kakobuy Spreadsheet
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left px-5 md:px-8 py-4 text-sm font-semibold text-foreground-800">Metoda</th>
                  <th className="text-center px-5 md:px-8 py-4 text-sm font-semibold text-foreground-500">
                    <i className="ri-google-line mr-1"></i>Google
                  </th>
                  <th className="text-center px-5 md:px-8 py-4 text-sm font-semibold text-primary-600 bg-primary-50/50">
                    <i className="ri-file-list-3-line mr-1"></i>Kakobuy Spreadsheet
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={row.label} className={`border-b border-background-100 ${i % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                    <td className="px-5 md:px-8 py-3.5 text-sm font-medium text-foreground-800">{row.label}</td>
                    <td className="px-5 md:px-8 py-3.5 text-sm text-center text-foreground-500">{row.google}</td>
                    <td className="px-5 md:px-8 py-3.5 text-sm text-center font-medium text-accent-700 bg-accent-50/30">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-check-line text-accent-500"></i>
                        {row.kakobuy}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Wypróbuj Kakobuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}